import { Component, OnInit } from '@angular/core';
import { SitesService } from '../sites.service';
import { MyBranchService } from '../my-branch.service';
import { SitePpeComponent } from '../my-day/site-ppe/site-ppe.component';
import { ActiveWoComponent } from '../my-day/active-wo/active-wo.component';
import { HeuristicsService } from '../heuristics.service';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { MovingFsComponent } from './moving-fs/moving-fs.component';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-my-branch',
  templateUrl: './my-branch.component.html',
  styleUrls: ['./my-branch.component.scss']
})
export class MyBranchComponent implements OnInit {

  sites = [];
  selectedBranch = {code: 'AAA', name: 'All'};
  activeBranches = [{code: '', name: ''}];
  currDate: Date = new Date();
  loading = true;
  showUpload = Number(localStorage.getItem('clearance')) > 4 ? true : false;
  fileName = '';
  sitesData = [];
  siteLeadsData = [];
  inspsData = [];
  sitesWithHandout = [];
  sitesWithHandoutReturned = false;
  sitesReturned = false;
  siteLeadsReturned = false;
  inspsReturned = false;
  sel = localStorage.getItem('selectedBranchCode') ? localStorage.getItem('selectedBranchCode') : localStorage.getItem('branch1');

  constructor(
    public dialog: MatDialog,
    public sitesService: SitesService,
    public myBranchService: MyBranchService,
    public heuristicsService: HeuristicsService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    if (localStorage.getItem('selectedDate') !== null) {
      this.currDate = new Date(localStorage.getItem('selectedDate'));
    } else {
      localStorage.setItem('selectedDate', this.getFormattedDate(this.currDate));
    }
    this.myBranchService.getActiveBranches().subscribe((data) => {
      this.populateBranches(data);
    });
  }

  populateBranches(data) {
    this.activeBranches = [this.selectedBranch];
    for (const item of data) {
      this.activeBranches.push({code: item.code, name: item.name});
      if (item.code === this.sel) {
        this.selectedBranch = {code: item.code, name: item.name};
        localStorage.setItem('selectedBranchName', item.name);
      }
    }
    this.activeBranches.sort((a, b) => {
      if (a.name !== 'All' && b.name !== 'All' && a.name < b.name) {
        return -1;
      } else if (a.name !== 'All' && b.name !== 'All' && a.name > b.name) {
        return 1;
      } else {
        return 0;
      }
    });
    this.fetchData();

  }

  changeBranch(e) {
    this.sites = [];
    this.loading = true;
    for (const branch of this.activeBranches) {
      if (branch.code === e.value) {
        localStorage.setItem('selectedBranchCode', branch.code);
        localStorage.setItem('selectedBranchName', branch.name);
        this.selectedBranch = {code: branch.code, name: branch.name};
      }
    }
    this.fetchData();
  }

  changeDate(t: any): void {
    this.sites = [];
    this.loading = true;
    this.currDate = t.value;
    localStorage.setItem('selectedDate', this.getFormattedDate(this.currDate));
    this.fetchData();
  }

  getFormattedDate( dt: Date ): string {
    let m: any = dt.getMonth() + 1;
    m = (m < 10) ? '0' + m.toString() : m.toString();
    let d: any = dt.getDate();
    d = (d < 10) ? '0' + d.toString() : d.toString();
    const formattedDate = dt.getFullYear().toString() + '-' + m.toString() + '-' + d.toString();
    return formattedDate;
  }

  fetchData(): void {
    // Clear stored vars and run async queries
    this.sitesData = [];
    this.siteLeadsData = [];
    this.inspsData = [];
    this.sitesWithHandoutReturned = false;
    this.sitesReturned = false;
    this.siteLeadsReturned = false;
    this.inspsReturned = false;
    this.getSitesWithHandout();
    this.getSitesForBranch();
    this.getSupervisorsData();
    this.getInspsData();
  }

  getSitesWithHandout(): void {
    this.myBranchService.getSitesWithHandout().subscribe((data) => {
      if (data) {
        this.sitesWithHandout = data;
      }
      this.sitesWithHandoutReturned = true;
      this.compileData();
    });
  }

  getSitesForBranch(): void {
    // Get active sites for the branch (or all)
    this.myBranchService.getSitesData(this.selectedBranch.code, this.getFormattedDate(this.currDate))
      .subscribe((data) => {
        this.sitesData = data;
        this.sitesReturned = true;
        this.compileData();
      });
  }

  getSupervisorsData(): void {
    // Get all leader entries
    this.myBranchService.getSiteLeadData()
      .subscribe((data) => {
        this.siteLeadsData = data;
        this.siteLeadsReturned = true;
        this.compileData();
      });
  }

  getInspsData(): void {
    // Get position assignments data for on site / covid
    this.myBranchService.getInspsData(this.getFormattedDate(this.currDate))
      .subscribe((data) => {
        this.inspsData = data;
        this.inspsReturned = true;
        this.compileData();
      });
  }

  compileData(): void {
    if (this.sitesReturned && this.siteLeadsReturned && this.inspsReturned && this.sitesWithHandoutReturned) {
      // Only run if all results received
      this.loading = false;
      this.sites = [];
      this.sitesData.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        } else {
          return 0;
        }
      });
      for (const site of this.sitesData) {
        const siteId = site.customerId;
        const supervisors = [];
        const shifts = [];
        let shiftItem = {};

        // Create shift containers for active sites
        if (site.isAM === 1) {
          shifts.push(shiftItem = {
            site: site.customerId,
            shift: site.c1label,
            startTime: site.c1StartTime,
            endTime: site.c1EndTime,
            total: 0,
            covid: 0,
            onSite: 0
          });
        }

        if (site.isPM === 1) {
          shifts.push(shiftItem = {
            site: site.customerId,
            shift: site.c2label,
            startTime: site.c2StartTime,
            endTime: site.c2EndTime,
            total: 0,
            covid: 0,
            onSite: 0
          });
        }

        if (site.isMN === 1) {
          shifts.push(shiftItem = {
            site: site.customerId,
            shift: site.c3label,
            startTime: site.c3StartTime,
            endTime: site.c3EndTime,
            total: 0,
            covid: 0,
            onSite: 0
          });
        }

        if (site.is4 === 1) {
          shifts.push(shiftItem = {
            site: site.customerId,
            shift: site.c4label,
            startTime: site.c4StartTime,
            endTime: site.c4EndTime,
            total: 0,
            covid: 0,
            onSite: 0
          });
        }

        if (site.is5 === 1) {
          shifts.push(shiftItem = {
            site: site.customerId,
            shift: site.c5label,
            startTime: site.c5StartTime,
            endTime: site.c5EndTime,
            total: 0,
            covid: 0,
            onSite: 0
          });
        }

        if (site.is6 === 1) {
          shifts.push(shiftItem = {
            site: site.customerId,
            shift: site.c6label,
            startTime: site.c6StartTime,
            endTime: site.c6EndTime,
            total: 0,
            covid: 0,
            onSite: 0
          });
        }

        // Populate Site Leaders into data ar
        for (const sl of this.siteLeadsData) {
          if (sl.site === site.customerId) {
            supervisors.push(sl);
          }
        }

        // Populate totals, covid, and on Site values
        for (const insp of this.inspsData) {
          if (insp.site === site.customerId) {
            for (const s of shifts) {
              if (s.shift === insp.shift) {
                s.total = insp.total;
                s.covid = insp.covid;
                s.onSite = insp.onSite;
              }
            }
          }
        }

        let agencyRequirements = '';
        let siteSpecifics = '';
        if (site.agencyRequirements === '' || site.agencyRequirements === null) {
          agencyRequirements = 'No PPE information available';
        } else {
          agencyRequirements = site.agencyRequirements;
        }
        if (site.comments === '' || site.comments === null) {
          siteSpecifics = 'No site specifics available';
        } else {
          siteSpecifics = site.comments;
        }

        this.sites.push({
          siteId,
          agencyRequirements,
          siteSpecifics,
          name: site.siteCustomerName,
          address1: `${site.streetNumber} ${site.streetName},`,
          address2: `${site.city}, ${site.state}, ${site.postalCode}`,
          shifts,
          supervisors,
          showDownload: this.sitesWithHandout.includes(`${siteId}.pdf`)
        });
      }
      this.loading = false;
    }
  }

  openSite(site: any) {
    let nm = site.name;
    if (nm.indexOf('/') > -1) {
      nm = nm.replace(/\//g, '#2F');
      this.router.navigate(['shifts/' + nm]);
    } else {
      this.router.navigate(['shifts/' + nm]);
    }
  }

  openActiveWo(site: any[]) {
    this.heuristicsService.addHeuristic('MyBranch', 'Active')
      .subscribe((data) => {});
    this.dialog.open(ActiveWoComponent, {width: '450px', autoFocus: true,
      data: {siteId: site['siteId'], name: site['name']}})
        .afterClosed().subscribe(result => {}
    );
  }

  openPPE(site: any[]) {
    this.heuristicsService.addHeuristic('MyBranch', 'PPE')
      .subscribe((data) => {});
    this.dialog.open(SitePpeComponent, {width: '600px', autoFocus: true,
    data: { title: 'PPE (' + site['name'] + ')', message: site['agencyRequirements']}})
      .afterClosed().subscribe(result => {}
    );
  }

  openSiteSpecifics(site: any[]) {
    this.heuristicsService.addHeuristic('MyBranch', 'Specifics')
      .subscribe((data) => {});
    this.dialog.open(SitePpeComponent, {width: '600px', autoFocus: true,
    data: { title: 'Site Specifics (' + site['name'] + ')', message: site['siteSpecifics']}})
      .afterClosed().subscribe(result => {}
    );
  }

  onFileSelected(event, site) {
    site.handoutLoading = true;
    const file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      const formData = new FormData();
      formData.append('item', file);
      this.myBranchService.uploadSiteHandout(formData, Number(site['siteId'])).subscribe(res => {
        if (res.status === 'complete') {
          site.handoutLoading = false;
        }
      });
    }
  }

  fileDownload(site) {
    site.handoutLoading = true;
    this.myBranchService.downloadSiteHandout(Number(site['siteId']), site['name']).subscribe((blob) => {
      if (blob && blob.type === 'application/pdf') {
        saveAs(blob, `Site Requirements-${site['name']}.pdf`);
      } else {
        this.dialog.open(SitePpeComponent, {
          width: '600px', autoFocus: true, data: { title: 'Error - ' + site['name'], message: 'No site handout avaialable'}})
          .afterClosed().subscribe(result => {});
      }
      site.handoutLoading = false;
    });
  }

  openMovingFS(supervisor) {
    this.dialog.open(MovingFsComponent, {width: '800px', autoFocus: true, data: { supervisor: supervisor }})
      .afterClosed().subscribe(result => {
        if (result && result.event.toString() === 'Close') {
          window.location.reload();
        }
      });
  }
}
